module.exports = {
          srcSet: __webpack_public_path__ + "images/1911-50ec4630192f8476f838e464a3923857-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1911-5e2af36d28b3a80ec600bf91bd1e6c3a-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1911-50ec4630192f8476f838e464a3923857-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1911-5e2af36d28b3a80ec600bf91bd1e6c3a-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1911-50ec4630192f8476f838e464a3923857-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1911-50ec4630192f8476f838e464a3923857-320.jpg"},
          
          width: 320,
          height: 251
        }